import { NotesPanelWebComponent } from './component/NotesPanelWebComponent';
import { WEB_COMPONENT_NOTES_PANEL } from '../../webcomponents.constants';

export { NotesPanelWebComponent };

window.customElements.define(WEB_COMPONENT_NOTES_PANEL, NotesPanelWebComponent);
